import React from 'react'
import { Button } from 'reactstrap'
import _ from 'lodash'

import { PARAMETER_NAME_LENGTH } from 'constants/ReceptionCustom'
import StyledSelect from 'containers/Reception/components/StyledSelect'
import { Input } from 'containers/Reception/components/utils'

import { HEADER_HEIGHT } from '../../constants'
import { CheckoutAdditionalField } from '../types'
import { TenantType, UserDataType } from 'utils/types'
import { INPUT_TYPE } from '../constants'
import CheckoutAdditionalFieldEditorRow from './CheckoutAdditionalFieldEditorRow'
import { useCheckoutAdditionalFieldEditor } from '../hooks/useCheckoutAdditionalFieldEditor'
import { useRegisterUnsavedChanges, UNSAVED_CHANGES_ID } from './UnsavedChangesContext'

const inputTypeOptions = [
  { value: INPUT_TYPE.TEXT, label: '記述式' },
  { value: INPUT_TYPE.NUMBER, label: '記述式(数値)' },
  { value: INPUT_TYPE.CHOICE, label: '選択式' },
]

type Props = {
  selectedField: CheckoutAdditionalField
  onClose: () => void
  onSave: (field: CheckoutAdditionalField) => void
  canUpdate: boolean
  tenantId: number
  tenants: TenantType[]
  userData: UserDataType
  openError: (message: string, useNetworkError?: boolean) => void
}

const CheckoutAdditionalFieldEditor: React.FC<Props> = ({
  selectedField,
  onClose,
  onSave,
  canUpdate,
  openError,
}) => {
  const {
    formData,
    isDirty,
    handleChangeVisibility,
    handleEmptyOption,
    handleChangeFieldName,
    handleChangeInputType,
    handleChangeOptionName,
    handleRegister,
  } = useCheckoutAdditionalFieldEditor({
    selectedField,
    onSave,
    onClose,
    openError,
  })

  // エディタの isDirty を登録
  useRegisterUnsavedChanges({ isDirty, id: UNSAVED_CHANGES_ID.EDITOR })

  return (
    <div>
      <div
        className="p-3"
        style={{ height: window.innerHeight - HEADER_HEIGHT }}
      >
        <div className="mx-auto pb-3" style={{ width: 600 }}>
          <div className="p-3 mb-3 bg-white border">
            <div className="mb-3 font-weight-bold">追加項目</div>
            <div className="mb-3">追加選択肢を作成し、表示したい追加項目を選択ください。</div>
            <div className="d-flex align-items-center mb-3">
              <div className="mr-3" style={{ width: 60 }}>
                項目名
              </div>
              <Input
                type="text"
                placeholder="入力してください"
                value={formData.displayName || ''}
                maxLength={PARAMETER_NAME_LENGTH}
                style={{ width: 200 }}
                onChange={handleChangeFieldName}
                disabled={!canUpdate}
              />
            </div>
            <div className="d-flex align-items-center mb-3">
              <div className="mr-3" style={{ width: 60 }}>
                形式
              </div>
              <div style={{ width: 200 }}>
                <StyledSelect
                  value={_.find(inputTypeOptions, { value: formData.inputType })}
                  options={inputTypeOptions}
                  onChange={handleChangeInputType}
                  isDisabled={!canUpdate}
                />
              </div>
            </div>
            {formData.inputType === INPUT_TYPE.CHOICE && (
              <div className="mb-2">
                <div style={{ overflowY: 'auto' }}>
                  {(formData.options || []).map((option, index) => (
                    <CheckoutAdditionalFieldEditorRow
                      key={index}
                      option={option}
                      index={index}
                      canUpdate={canUpdate}
                      onChangeVisibility={handleChangeVisibility}
                      onChangeOptionName={handleChangeOptionName}
                      onRemove={handleEmptyOption}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="d-flex justify-content-between">
            <Button
              outline
              color="primary"
              className="text-primary bg-white rounded-pill px-4"
              onClick={onClose}
            >
              もどる
            </Button>

            {canUpdate && (
              <Button
                color="primary"
                className="rounded-pill px-4"
                disabled={!isDirty}
                onClick={handleRegister}
              >
                登録
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(CheckoutAdditionalFieldEditor)
